import dashboard from "../components/views/dashboard/dashboard.vue";

const routes = [
  {
    path: "",
    component: dashboard,
    name: "dashboard",
    meta: {
      title: 'Dashboard'
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.route.js